import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function EyeCross({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M14.55 13.55H14.549C13.699 14.97 11.859 15.44 10.429 14.6C8.99898 13.75 8.52898 11.91 9.36898 10.48C9.61898 10.04 9.97898 9.68 10.419 9.42M17.99 16.99C16.26 18.29 14.149 19 11.989 18.99C8.39898 19.05 5.08898 17.08 3.43498 13.9H3.42998C2.82998 12.69 2.82998 11.28 3.42998 10.07C4.24998 8.42 5.56998 7.07 7.19998 6.2M20.42 14.13C20.46 14.05 20.51 13.98 20.55 13.9C21.14 12.69 21.14 11.28 20.55 10.07C18.89 6.88 15.579 4.91 11.989 4.98C11.759 4.98 11.539 5.01 11.319 5.02M21 20L3.99998 3" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default EyeCross;